import { axiosBaseQuery } from '@/lib/axiosBaseQuery.ts'
import { LoginResponseDto } from '@/types/auth.ts'
import { createApi } from '@reduxjs/toolkit/query/react'

export const authApi = createApi({
	reducerPath: 'authApi',
	tagTypes: ['AuthUser'],
	baseQuery: axiosBaseQuery(),
	endpoints: build => ({
		getLoggedInUser: build.query<LoginResponseDto, void>({
			query: () => ({ url: `/employees/user`, method: 'GET' }),
		}),
	}),
})

export const { useGetLoggedInUserQuery } = authApi
